import React from 'react';
import { Cloud, Shield, Brain, Settings } from 'lucide-react';
import { services } from '../data/mock';

const ServicesSection = () => {
  const serviceIcons = {
    1: Cloud,
    2: Shield,
    3: Brain,
    4: Settings
  };

  return (
    <section id="services" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">Our Services</h2>
          <p className="body-large max-w-4xl mx-auto">
            Comprehensive technology solutions designed for the unique needs of MENA region businesses
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = serviceIcons[service.id];
            return (
              <div
                key={service.id}
                className="p-8 rounded-lg dark-transition dark-hover"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center" style={{ 
                    background: 'rgba(0, 255, 209, 0.2)' 
                  }}>
                    <IconComponent size={24} style={{ color: '#00FFD1' }} />
                  </div>
                  <div className="flex-1">
                    <h3 className="heading-2 mb-4">{service.title}</h3>
                    <p className="body-medium mb-6">{service.description}</p>
                    
                    <div className="space-y-2">
                      <h4 className="heading-3 mb-3">Key Features:</h4>
                      <ul className="space-y-2">
                        {service.features.map((feature, index) => (
                          <li key={index} className="flex items-center space-x-2">
                            <div className="w-2 h-2 rounded-full" style={{ background: '#00FFD1' }}></div>
                            <span className="body-small">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-16">
          <button className="btn-primary">
            <span>Explore All Solutions</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;